import { observer } from 'mobx-react';

import Button, { NEUTRAL_NOT_SO_LIGHT, PRIMARY } from '@/common/components/Button/Button';
import ButtonContainer from '@/common/components/ButtonContainer/ButtonContainer';
import DocumentationLink from '@/common/components/DocumentationLink/DocumentationLink';
import { useAppStore } from '@/common/stores/AppStore';

import styles from './GlobalAccessModalFooter.module.css';

export interface GlobalAccessModalFooterProps {
  docHref: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isSubmitDisabled?: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

function GlobalAccessModalFooter(props: GlobalAccessModalFooterProps) {
  const { docHref, isDisabled = false, isLoading = false, isSubmitDisabled = false, onClose, onSubmit } = props;
  const { isPhone } = useAppStore();

  return (
    <div className={styles.accessModalFooter}>
      <DocumentationLink href={docHref} />

      <ButtonContainer>
        <Button aria-label="Cancel" color={NEUTRAL_NOT_SO_LIGHT} disabled={isDisabled} onClick={onClose} wide={!isPhone}>
          Cancel
        </Button>

        <Button aria-label="Ok" color={PRIMARY} disabled={isSubmitDisabled} loading={isLoading} onClick={onSubmit} wide={!isPhone}>
          Ok
        </Button>
      </ButtonContainer>
    </div>
  );
}

export default observer(GlobalAccessModalFooter);
